<search>
  <a
    class="dfkv-reset float-right fw-bold"
    href="#!"
  >{t('reset')}</a>

  <h2 class="mb-4">
    {cap(t('search_criteria'))}
  </h2>

  <dfk-input
    placeholder={cap(t('search_prompt'))}
    type="text"
    name="terms"
    update-handler={onInputDelayed}
    value={props.criteria.terms}
  />

  <range-control
    if={props.results}
    from={props.criteria.from}
    to={props.criteria.to}
    min={minDate()}
    max={maxDate()}
    bins={monthBins()}
    on-inputs-changed={props.onInput}
    class="mt-5 mb-5"
  />

  <div if={hasActiveFilters()} class="dfkv-active-filters">
    <h2 class="mt-5">{cap(t('your_selection'))}</h2>

    <dfk-active-filters
      criteria={props.criteria}
      params={['category', 'person', 'location', 'section']}
      translate-keys={true}
      remove-filter={(param, value) => removeFilter(param, value)}
    />
  </div>

  <h2 class="mt-5">{cap(t('filters'))}</h2>

  <div
    is="facet"
    if={props.results}
    name={cap(t('categories'))}
    aggregation={props.results.buckets.category}
    add-filter={newFilter => addFilter(newFilter)}
    type={'category'}
    class="d-block"
    icon="tag"
    always-show-toggle={true}
    on-expand={event => expand('categories')}
  />

  <div
    is="facet"
    if={props.results}
    name={cap(t('people'))}
    aggregation={props.results.buckets.person}
    add-filter={newFilter => addFilter(newFilter)}
    type={'person'}
    class="d-block mt-5"
    icon="person"
    always-show-toggle={true}
    on-expand={event => expand('people')}
  />

  <div
    is="facet"
    if={props.results}
    name={cap(t('locations'))}
    show-all-label={t('to_map')}
    aggregation={props.results.buckets.location}
    add-filter={newFilter => addFilter(newFilter)}
    type={'location'}
    class="d-block mt-5"
    icon="location"
    always-show-toggle={true}
    on-expand={event => expand('locations')}
  />

  <div
    is="facet"
    if={props.results}
    name={cap(t('sections'))}
    aggregation={props.results.buckets.section}
    add-filter={newFilter => addFilter(newFilter)}
    type={'section'}
    class="d-block mt-5"
    icon="section"
    always-show-toggle={true}
    on-expand={event => expand('sections')}
  />

  <dfk-popup open={state.expansion} container={root}>
    <category-selector
      if={props.results && state.expansion == 'categories'}
      criteria={props.criteria}
      aggregation={props.results.buckets.category}
      add-filter={newFilter => addFilter(newFilter)}
      on-close={event => collapse()}
    />

    <person-selector
      if={props.results && state.expansion == 'people'}
      criteria={props.criteria}
      aggregation={props.results.buckets.person}
      add-filter={newFilter => addFilter(newFilter)}
      on-close={event => collapse()}
    />

    <location-selector
      if={props.results && state.expansion == 'locations'}
      criteria={props.criteria}
      aggregation={props.results.buckets.location}
      add-filter={newFilter => addFilter(newFilter)}
      on-close={event => collapse()}
    />

    <section-selector
      if={props.results && state.expansion == 'sections'}
      criteria={props.criteria}
      aggregation={props.results.buckets.section}
      add-filter={newFilter => addFilter(newFilter)}
      on-close={event => collapse()}
    />

    <!-- <watchlist
      if={props.results && state.expansion == 'watchlist'}
      criteria={props.criteria}
      on-close={event => collapse()}
    /> -->
  </dfk-popup>

  <script>
    import {util} from '@wendig/lib'
    import {strftime} from '../lib/util'

    import DfkPopup from '@dfk-paris/frontend/src/components/popup.riot'
    import CategorySelector from './category_selector.riot'
    import LocationSelector from './location_selector.riot'
    import PersonSelector from './person_selector.riot'
    import SectionSelector from './section_selector.riot'

    export default class {
      static components = {
        DfkPopup,
        CategorySelector,
        LocationSelector,
        PersonSelector,
        SectionSelector
      }

      onBeforeMount(props) {
        this.onInputDelayed = util.delay(props.onInput, 600)

        this.on('scroll-to-top', event => {
          this.root.scrollIntoView({behavior: 'smooth'})
        })
      }

      addFilter(value) {
        for (const [k, v] of Object.entries(value)) {
          let current = this.props.criteria[k]
          current = current ? current.split('|') : []
          const index = current.indexOf(v)

          if (index == -1) {
            current.push(v)
            this.props.onInput({[k]: current.join('|')})
          }
        }
      }

      removeFilter(value) {
        this.props.onInput(value)
      }

      hasActiveFilters() {
        const keys = [
          'location', 'person', 'category', 'section'
        ]

        for (const k of keys) {
          if (this.props.criteria[k]) return true
        }

        return false
      }

      minDate() {
        return `${this.minMonth()}-01`
      }

      maxDate() {
        let date = new Date(`${this.maxMonth()}-01`)
        date.setUTCMonth(date.getUTCMonth() + 1)
        date.setUTCDate(0)

        return strftime('%Y-%m-%d', date)
      }

      minMonth() {
        return '1930-08'
      }

      maxMonth() {
        return '1938-12'
      }

      monthBins() {
        const buckets = this.props.results.buckets.month.buckets || []

        const counts = {}
        for (const b of buckets) {
          counts[b['key']] = b['doc_count']
        }

        let results = []
        let name = ''
        let [y, m] = this.minMonth().split('-').map(e => parseInt(e))
        const [maxY, maxM] = this.maxMonth().split('-').map(e => parseInt(e))
        while (y <= maxY && m <= maxM) {
          name = `${y}-${String(m).padStart(2, '0')}`
          results.push(counts[name] || 0)

          m += 1
          if (m > 12) {
            y += 1
            m = 1
          }
        }

        return results
      }

      onDateInput() {
        console.log(arguments)
      }

      collapse() {
        this.expand(null)
      }

      expand(facet = null) {
        const newState = (this.state.expansion == facet ? null : facet)
        this.update({expansion: newState})
      }
    }
  </script>
</search>
